/* Unofficial Alton Towers — auto-scrolling homepage ride queues */
(function () {
  "use strict";
  var root=document.getElementById("uato-home-queues");
  if(!root || root.dataset.initialised==="true") return;
  root.dataset.initialised="true";
  var viewport=root.querySelector("[data-uato-queue-viewport]");
  var track=root.querySelector("[data-uato-queue-track]");
  var primary=root.querySelector("[data-uato-queue-items]");
  var status=root.querySelector("[data-uato-queue-status]");
  var endpoint=root.dataset.queueEndpoint;
  var key=root.dataset.queueKey;
  if(!viewport || !primary || !track || !status || !endpoint || !key) return;
  var priority=["Nemesis Reborn","The Smiler","Wicker Man","Oblivion","TH13TEEN","Galactica","Rita","Toxicator","Spinball Whizzer","Nemesis Sub-Terra","The Curse at Alton Manor","Runaway Mine Train","Congo River Rapids","Bluey the Ride: Here Come the Grannies!"];
  var priorityMap=new Map(priority.map(function(n,i){return [norm(n),i]}));
  var mazeNames=["Final Exhibit","Edge of the Forest","COMPOUND","Altonville Mine Tours","Dark Forest","Burial Grounds"];
  var known=["Nemesis Reborn","The Smiler","Wicker Man","Oblivion","TH13TEEN","Galactica","Rita","Toxicator","Spinball Whizzer","Nemesis Sub-Terra","The Curse at Alton Manor","Runaway Mine Train","Congo River Rapids","Bluey the Ride: Here Come the Grannies!","Octonauts Rollercoaster Adventure","Gangsta Granny: The Ride","Hex - The Legend of the Towers","Skyride"];
  var links=new Map(known.map(function(n){return [norm(n),"/pages/ride-"+slug(n)]}));
  var reduced=window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var loaded=false;
  var parkClosed=false;
  var lastFrame=0,feedCheckAt=0,busy=false,feedError=false,lastRides=[];
  var feedFreshness=15*60*1000,olderReportLimit=90*60*1000;
  function norm(n){return String(n||"").toLowerCase().replace(/\[archived\]/g,"").replace(/[^a-z0-9]/g,"")}
  function slug(n){return String(n||"").toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/(^-|-$)/g,"")}
  function isMaze(n){var s=norm(n);if(s.indexOf("skyride")!==-1)return false;return mazeNames.some(function(m){var t=norm(m);return s===t||s.indexOf(t)===0})}
  function elem(tag,className,text){var e=document.createElement(tag);if(className)e.className=className;if(text!==undefined)e.textContent=String(text);return e}
  function london(ms){try{return new Intl.DateTimeFormat("en-GB",{timeZone:"Europe/London",hour:"2-digit",minute:"2-digit"}).format(new Date(ms))}catch(_){return "unknown"}}
  function makeCard(r){
    var model=window.UATOFeed.classifyRide(r,parkClosed,Date.now(),feedError);
    var card=elem("article","uato-home-queues__card uato-home-queues__card--"+(model.code==="closed"?"closed":"open"));
    var detail=elem("div","uato-home-queues__details");
    var href=links.get(norm(r.name)),name=elem(href?"a":"strong","uato-home-queues__name",r.name);
    if(href)name.href=href;
    detail.append(name);
    var badge=elem("div","uato-home-queues__minutes");
    if(model.code==="closed")badge.append(elem("strong","","×"),elem("span","","Closed"));
    else badge.append(elem("strong","",String(model.value)),elem("span","","min"));
    card.append(detail,badge);
    return card;
  }
  function normalise(data){
    if(!window.UATOFeed||typeof window.UATOFeed.normaliseRides!=="function")throw Error("Shared queue model unavailable");
    return window.UATOFeed.normaliseRides(data).filter(function(r){return !isMaze(r.name)}).sort(function(a,b){
      var x=priorityMap.has(norm(a.name))?priorityMap.get(norm(a.name)):999;
      var y=priorityMap.has(norm(b.name))?priorityMap.get(norm(b.name)):999;
      return x-y||a.name.localeCompare(b.name);
    });
  }
  function setStatus(text,state){status.textContent=text;status.dataset.state=state||"";status.hidden=!text}
  function resetCards(rides){
    var previousWidth=primary.getBoundingClientRect().width;
    var previousScroll=viewport.scrollLeft;
    var fragment=document.createDocumentFragment();
    rides.forEach(function(r){fragment.appendChild(makeCard(r))});
    primary.replaceChildren(fragment);
    track.querySelectorAll("[data-uato-queue-copy]").forEach(function(x){x.remove()});
    if(rides.length>1) {
      var clone=primary.cloneNode(true);
      clone.removeAttribute("data-uato-queue-items");clone.setAttribute("data-uato-queue-copy","true");clone.setAttribute("aria-hidden","true");
      clone.querySelectorAll("a").forEach(function(a){a.tabIndex=-1});
      track.appendChild(clone);
    }
    var newWidth=primary.getBoundingClientRect().width;
    viewport.scrollLeft=previousWidth > 0 && newWidth > 0 ? (previousScroll % previousWidth) * newWidth / previousWidth : 0;
    loaded=rides.length>1;
  }
  async function load(){
    if(busy)return;busy=true;
    try {
      if(!window.UATOFeed || typeof window.UATOFeed.queues!=="function")throw Error("Queue client unavailable");
      var parkInfo=null;
      try { if(window.UATOFeed.parkState)parkInfo=await window.UATOFeed.parkState(); } catch(_) {}
      parkClosed=!!(parkInfo && parkInfo.status==="closed");
      var data=await window.UATOFeed.queues(endpoint,key),rides=normalise(data);
      var health=Array.isArray(data._uatoSourceHealth)?data._uatoSourceHealth:null;
      var sourceNote=health?" · "+health.filter(function(x){return x.ok;}).length+"/"+health.length+" data sources responding":"";
      if(!rides.length)throw Error("Empty ride feed");
      feedError=false;lastRides=rides;
      var visible=rides.filter(function(r){return window.UATOFeed.classifyRide(r,parkClosed).code!=="unknown";});
      resetCards(visible);
      setStatus(visible.length?"":"Current queue information is temporarily unavailable.","");

    } catch(err) {
      if(parkClosed){
        resetCards(priority.map(function(name){return {id:norm(name),name:name,area:"Alton Towers",isOpen:false,wait:null,updated:null};}));
        setStatus("","");
      }else{
        feedError=true;resetCards([]);
        setStatus("Current queue information is temporarily unavailable.","warn");
      }
    }finally{busy=false;feedCheckAt=Date.now()}
  }
  var loopOffset=0;
  function frame(t){
    if(loaded && !reduced && document.visibilityState!=="hidden") {
      var width=primary.getBoundingClientRect().width;
      if(width>0 && lastFrame) {
        loopOffset=(loopOffset+(Math.min(75,t-lastFrame)/1000)*140)%width;
        viewport.scrollLeft=loopOffset;
        if(Math.abs(viewport.scrollLeft-loopOffset)>2) {
          track.style.transform="translate3d("+(-loopOffset)+"px,0,0)";
          viewport.scrollLeft=0;
        } else {
          track.style.transform="";
        }
      }
    }
    lastFrame=t;
    requestAnimationFrame(frame);
  }
  resetCards([]);
  requestAnimationFrame(frame);
  load();
  setInterval(function(){if(document.visibilityState!=="hidden")load()},60000);
  document.addEventListener("visibilitychange",function(){if(document.visibilityState==="visible" && Date.now()-feedCheckAt>=60000)load()});
})();